enum Difficulty{
    EASY = "Easy",
    NORMAL = "Normal",
    HARD = "Hard",
    EXPERT = "Expert",
    EXPERT_PLUS = "ExpertPlus",
    UNKNOWN = ""
}
export default Difficulty